'use client';

import { useEffect } from 'react';

import type { OrigemAbaAuditoria } from '@/shared/types/contextoAuditoria';
import { declararOrigemAba, limparOrigemAba } from '@/shared/utils/contextoAuditoria';

/**
 * Declara de onde a pessoa está agindo, enquanto a tela estiver montada.
 *
 * A trilha do processo arbitral grava, junto com cada ato, a origem (`X-Origem-Aba`) e a
 * coordenada (`X-Client-Geo`) — e a coordenada **só acompanha uma aba declarada**. Sem esta
 * chamada, o ato entra na trilha sem "de onde", e num documento probatório isso não pode
 * depender de qual painel a pessoa usou.
 *
 * O hook existe porque o mesmo `useEffect` de três linhas — declarar na montagem, limpar no
 * cleanup — se repetia em cada painel, e a parte fácil de esquecer é justamente o cleanup: sem
 * ele, a aba anterior continua sendo anunciada em telas que não a declararam.
 *
 * @example useOrigemAbaAuditoria('PAINEL_ARBITRO');
 */
export function useOrigemAbaAuditoria(aba: OrigemAbaAuditoria): void {
  useEffect(() => {
    void declararOrigemAba(aba);
    return () => {
      limparOrigemAba();
    };
  }, [aba]);
}
